module.exports = __webpack_public_path__ + "img/汉堡按钮.7645d2f1.svg";